import { FormikParticipantByProvingPicker } from 'components/ParticipantListPicker'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import * as React from 'react'
import * as Yup from 'yup'

export const ParticipantsByProvingFormSchema = Yup.object().shape({
  participants: Yup.array().required().min(1),
})

export const ParticipantsByProvingForm: React.FC = () => {
  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          name={'participants'}
          component={FormikParticipantByProvingPicker}
        />
      </FieldStack>
    </FormStack>
  )
}
